import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import OtpInput from "../components/OtpInput";
import { AUTH_STORAGE_KEYS, authVerifyEmail, clearAuthFlow, getAuthValue, setAuthFlowStep } from "../api/authApi";

export default function VerifyEmail() {
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const partnerId = getAuthValue(AUTH_STORAGE_KEYS.partnerId);
  const challengeId = getAuthValue(AUTH_STORAGE_KEYS.challengeId);

  useEffect(() => {
    if (!partnerId || !challengeId) {
      navigate("/");
    }
  }, [partnerId, challengeId, navigate]);

  const handleVerifyEmail = async (otpValue) => {
    const code = String(otpValue ?? otp).trim();
    setError("");
    if (!code) {
      setError("OTP code is required");
      return;
    }

    try {
      setLoading(true);
      const data = await authVerifyEmail(challengeId, code);

      if (data.status === "totp_required") {
        setAuthFlowStep("totp_verify");
        navigate("/2fa/verify");
        return;
      }

      if (data.status === "totp_setup_required") {
        setAuthFlowStep("totp_setup");
        navigate("/2fa/setup");
        return;
      }

      throw new Error(data?.error || "Unexpected response");
    } catch (e) {
      setError(e.message || "Unable to verify email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Email verification"
      subtitle="Enter the OTP code sent to your email."
    >
      <div className="mb-2">
        <OtpInput
          value={otp}
          onChange={(next) => {
            if (error) setError("");
            setOtp(next);
          }}
          disabled={loading}
        />
      </div>

      {error && (
        <div className="mt-2 text-[12px] text-red-600 text-center">{error}</div>
      )}

      <button
        type="button"
        onClick={() => handleVerifyEmail()}
        disabled={loading}
        className={`w-full h-[44px] text-white px-[20px] mt-[15px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 ${
          loading
            ? "bg-[#cccccc] cursor-default opacity-60"
            : "bg-[#3d3935] border border-[#0f61a1] hover:opacity-80"
        }`}
      >
        {loading ? "Verifying..." : "Verify email"}
      </button>

      <button
        type="button"
        onClick={() => {
          clearAuthFlow();
          navigate("/");
        }}
        className="w-full h-[44px] bg-transparent border border-[#d2d2d2] text-[#3d3935] px-[20px] mt-[10px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 hover:opacity-80"
      >
        Back
      </button>
    </AuthShell>
  );
}